module.exports = __webpack_public_path__ + "img/MGM-logo.eeb7e3d5.jpg";